import { render } from "./ContactCoach.vue?vue&type=template&id=4038446e&scoped=true"
import script from "./ContactCoach.vue?vue&type=script&lang=js"
export * from "./ContactCoach.vue?vue&type=script&lang=js"

import "./ContactCoach.vue?vue&type=style&index=0&id=4038446e&scoped=true&lang=css"

import exportComponent from "D:\\Users\\וינברג\\Documents\\Vue\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4038446e"]])

export default __exports__